import React from "react";
import Helper from "../functions/Helper.js";
import { affiliateData } from "../functions/tracking.js";

const getdataSetVars = (colorway) => affiliateData({
  shop: colorway.shop_name, price: colorway.price_discount, listPrice: colorway.list_price,
  product: colorway.shoe_name, styleId: colorway.style_id, styleName: colorway.style_name,
  brand: colorway.brand, resale: colorway.type === "resell",
});

function DealRow(props) {
  let colorway = props.colorway;
  const trackingId = props.trackingId || "shop_comparison";
  let discount = Math.round(
    (1 - colorway.price_discount / colorway.list_price) * 100
  );

  return (
    <div
      style={{
        display: "flex",
        flex: 1,
        flexDirection: "row",
        padding: "8px 0px",
        borderTopWidth: props.index === 0 ? 0 : 1,
        borderColor: "#f0f0f0",
        borderStyle: "solid",
        ...props.style,
      }}
      key={colorway.colorway_id}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <div>
          <div
            style={{
              color: "#333333",
              fontSize: 16,
              lineHeight: 1.3,
              fontWeight: 500,
              textTransform: "uppercase",
            }}
          >
            {colorway.shop_name}
          </div>
        </div>
        <div
          style={{
            display: "flex",
            marginTop: 2,
            lineHeight: 1.3,
            flexDirection: "row",
          }}
        >
          {props.colorway.type === "resell" && <span>from&nbsp;</span>}
          <a
            data-tracking-id={trackingId + "_price"}
            {...getdataSetVars(colorway)}
            href={Helper.insert_link(
              colorway.link_url,
              trackingId + "_price",
              colorway.tracking_id
            )}
          >
            <span
              style={{
                fontWeight: "600",
                color:
                  discount > 1 && props.colorway.type !== "resell"
                    ? "#e32b2b"
                    : "black",
              }}
            >
              ${colorway.price_discount}
            </span>
          </a>
          {discount > 1 && props.colorway.type !== "resell" && (
            <div
              style={{
                color: "#767676",
                textDecorationLine: "line-through",
                textDecorationStyle: "solid",
                marginLeft: 5,
              }}
            >
              ${Math.round(Number(colorway.list_price))}
            </div>
          )}
        </div>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          justifyContent: "center",
          alignItems: "flex-end",
        }}
      >
        <a
          data-tracking-id={trackingId + "_button"}
          {...getdataSetVars(colorway)}
          target="_blank"
          rel="noopener nofollow"
          href={Helper.insert_link(
            colorway.link_url,
            trackingId + "_button",
            colorway.tracking_id
          )}
          css={{
            ":hover": { textDecoration: "none", color: "white" },
            color: "white",
            fontWeight: "700",
            borderRadius: 2,
            padding: "8px 30px",
            fontSize: 14,
            backgroundColor: "#319795",
          }}
        >
          Check sizes
        </a>
      </div>
    </div>
  );
}

export default DealRow;
